import { render, staticRenderFns } from "./index.vue?vue&type=template&id=24cc927e&scoped=true&lang=html&"
import script from "./distributionList.js?vue&type=script&lang=js&"
export * from "./distributionList.js?vue&type=script&lang=js&"
import style0 from "./distributionList.styl?vue&type=style&index=0&id=24cc927e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24cc927e",
  null
  
)

export default component.exports